export function RoleList (flag) {
  if (flag) {
    return ['/user/order', '/ZfbPay', '/WxPay', '/pay', '/createOrder', '/salesReturn', '/user/logistics', '/user/orderDetail', '/user/afterSale', '/cart']
  } else {
    return ['/user/', '/ZfbPay', '/WxPay', '/pay', '/createOrder', '/salesReturn', '/cart', '/search', '/shopDetail', '/flagship', '/storeShop', '/Seckill']
  }
}
